import { AsyncPipe, NgClass, NgForOf, NgIf, UpperCasePipe } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { ItemsModalService } from '../../../pages/items/items-modal/items-modal.service';
import { EWorkflow } from '../../../pages/items/items.interface';
import { ELoadStatus } from '../../../state/state.interface';
import { InlineMenuPositionService } from '../../../utilities/inline-menu-position.service';
import { IBoardMembers } from '../inline-user-chip/inline-user-chip.store';
import { IDropdownOption } from '../mat-dropdown/mat-dropdown.component';
import { InlineItemStatusChipStore } from './inline-item-status-chip.store';

@Component({
  imports: [
    NgIf,
    UpperCasePipe,
    FormsModule,
    MatMenu,
    MatMenuItem,
    TranslatePipe,
    NgForOf,
    MatIcon,
    NgClass,
    AsyncPipe,
    MatMenuTrigger,
    MatMenuContent,
  ],
  providers: [InlineItemStatusChipStore],
  selector: 'app-inline-item-status-chip',
  styleUrl: './inline-item-status-chip.component.scss',
  templateUrl: './inline-item-status-chip.component.html',
})
export class InlineItemStatusChipComponent implements OnInit, AfterViewInit {
  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;
  @Input() currentWorkflowStepId: number | null = null;
  @Input() boardItemConfigurationId: number | null = null;
  @Input() itemId: number | null = null;
  @Output() loadItem = new EventEmitter<void>();

  public workflowStepOptions: IDropdownOption[] = [];
  public menuYPosition: 'above' | 'below' = 'below';
  public menuXPosition: 'before' | 'after' = 'after';

  protected readonly ELoadStatus = ELoadStatus;
  protected readonly EWorkflow = EWorkflow;

  constructor(
    public readonly store: InlineItemStatusChipStore,
    public readonly itemsModalService: ItemsModalService,
    public readonly inlineMenuPositionService: InlineMenuPositionService,
  ) {}

  public ngOnInit(): void {
    this.store.editItemLoading$.subscribe((status: ELoadStatus) => {
      if (status === ELoadStatus.success) {
        this.loadItem.emit();
      }
    });

    this.store.workflowStepAssignmentsLoading.subscribe((status: ELoadStatus) => {
      if (
        status === ELoadStatus.success &&
        this.store.workflowStepAssignments().length > 0 &&
        this.currentWorkflowStepId
      ) {
        this.workflowStepOptions = this.itemsModalService.prepareWorkflowStepOptions(
          this.store.workflowStepAssignments(),
          this.currentWorkflowStepId,
          true,
        );

        this.workflowStepOptions = this.workflowStepOptions.filter(
          (option: IDropdownOption<number, string>) => option.id !== this.currentWorkflowStepId,
        );
      }
    });
  }

  public ngAfterViewInit(): void {
    this.menuTrigger.menuOpened.subscribe(() => {
      if (this.boardItemConfigurationId) {
        this.store.getWorkflowStepAssignments({ boardItemConfigurationId: this.boardItemConfigurationId });
      }
    });
  }

  public selectMenuItem(currentWorkflowStep: IBoardMembers): void {
    if (currentWorkflowStep?.id && this.itemId) {
      this.store.editItemCurrentWorkflowStepId({
        currentWorkflowStepId: currentWorkflowStep?.id,
        id: this.itemId,
      });
    }
  }

  public setMenuPosition(triggerElem: HTMLElement): void {
    const { yPosition, xPosition } = this.inlineMenuPositionService.calculateMenuPosition(triggerElem);
    this.menuYPosition = yPosition;
    this.menuXPosition = xPosition;
  }

  public onTriggerClick(triggerElem: HTMLElement): void {
    this.setMenuPosition(triggerElem);

    setTimeout(() => {
      this.menuTrigger.openMenu();
    });
  }
}
